import { Switch } from '@mui/material';
import { useEffect, useState } from 'react';

interface Iprops {
  value: boolean;
  label?: string;
  change: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  marginTop?: number;
  marginLeft?: number;
  disabled?: boolean;
  title?: string;
  testId?: string;
}
const FuelToggleButton = ({
  value,
  label,
  change,
  marginTop = -14,
  marginLeft = -3,
  disabled = false,
  title = '',
  testId = 'fuel-toggle-button',
}: Iprops) => {
  // console.log('FuelToggleButton', value, label);
  const [checked, setChecked] = useState(value);
  const [innerDisabled, setDisabled] = useState(disabled);

  useEffect(() => {
    // console.log('value---', value);
    setChecked(value);
  }, [value]);

  useEffect(() => {
    // console.log('disabled changed', disabled);
    setDisabled(disabled);
  }, [disabled]);

  return (
    <Switch
      title={title}
      className="fuel-toggle"
      data-testid={testId}
      sx={{ marginTop: `${marginTop}px`, marginLeft: `${marginLeft}px` }}
      inputProps={{ 'aria-label': label }}
      checked={checked}
      onChange={change}
      size="small"
      disabled={innerDisabled}
    />
  );
};

export default FuelToggleButton;
